<template>
  <div class="container" ref="container">
    <Header :scrollTop="scrollTop" />

    <div class="main">
      <img src="../../assets/banner1.jpeg" class="banner" />

      <div class="main-wrap" v-if="isReal">
        <template v-if="storeCode">
          <div class="time" v-show="status === 4 || status === 2">
            <span v-if="status == 2">距离本轮发券还剩</span>
            <span v-if="status === 1 || status === 4">距离下一轮发券还剩</span>

            <van-count-down
              :time="startTime"
              format="DD 天 HH 时 mm 分 ss 秒"
              @finish="onTimeFinish"
              :auto-start="run"
            />
          </div>
          <!-- <div :class="['ticket', !canUse() ? 'filter' : '']"> -->
          <div :class="['ticket', status !== 0 && !ticket ? 'filter' : '']">
            <div
              :class="['item', canUse(item) ? '' : 'filter']"
              v-for="item in list"
              :key="item.id"
            >
              <div class="top">
                <div class="info">
                  <span class="title">
                    <span style="fontsize: 0.4rem">￥</span
                    >{{ item.value }}</span
                  >
                  <span class="tips">{{ item.limit }}</span>
                </div>
              </div>
              <div class="bottom" v-if="status === 0" @click="onRush(item)">
                {{ returnBtnText(item.value) }}
                <!-- {{ ticket && ticket == item.value ? "已领取" : "立即领取" }} -->
              </div>
              <div
                class="bottom"
                v-if="status === 1 || status === 4 || status === 5"
              >
                {{ ticket && ticket == item.value ? "已领取" : "本轮已抢完" }}
              </div>
              <div class="bottom" v-if="status === 3">已结束</div>
              <div class="bottom" v-if="status === 2">未开始</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="tips"
            style="color: #ff5091; text-align: center"
            v-html="'实名认证已完成</br>您已获取到店领取资格'"
          >
            <!-- 请等待活动开始前往指定4s店线下领用 -->
          </div>
        </template>
      </div>

      <div class="form-wrap" v-if="!isReal">
        <template>
          <div class="tips" style="color: #ff5091">请本人正确填写以下信息</div>

          <van-field v-model="name" placeholder="请填写真实姓名" clearable />
          <van-field
            v-model="idCard"
            placeholder="请填写身份证号码"
            clearable
          />
          <van-field
            v-model="phone"
            placeholder="请填写正确的手机号"
            type="tel"
            maxlength="11"
            clearable
          />

          <div class="btn" @click="onSubmit" v-if="!isSend">提交认证</div>
          <div class="btn grey-bg" v-else>
            <van-count-down
              :time="time"
              format="ss 秒后重试"
              @finish="onSendFinish"
            />
          </div>

          <!-- <div class="tips">
            本次认证将于 <span>{{ realEndTime }}</span> 截止
          </div> -->
        </template>

        <!-- <template v-else>
          <div class="tips-cannot-real">
            <div>您未获得本次抢券资格</div>
            <div>本轮资格认证于{{ realEndTime }}截止</div>
            <div>请等待下一轮资格认证</div>
            <div>下轮资格认证将于14:00点开始</div>
          </div>
        </template> -->
      </div>
      <div class="getOneBtn flexCenter" @click="toScan()">
        <div class="scanIcon"></div>
        <div>扫码领取</div>
      </div>
    </div>

    <div class="ticket-wrap" v-if="ticket">
      <div class="ticket">
        <div class="left">
          <span style="fontsize: 0.4rem">￥</span>{{ ticket }}
        </div>
        <div class="right">
          <div class="info">
            <span class="title">吴兴区金秋汽车消费券</span>
            <span class="tips">{{ limitMap[ticket] }}</span>
            <span class="date">有效期：9月23日</span>
            <!-- <span class="date">有效期：{{ beginTime }}~{{ endTime }}</span> -->
          </div>
          <div class="btn" @click="onCheckTicket">查看</div>
        </div>
      </div>
    </div>

    <Rules />

    <Member />

    <CodeInput ref="codeRef" :phone="phone" @onCodeSubmit="onCodeSubmit" />

    <van-popup v-model="ticketShow">
      <div class="info-wrap">
        <img src="@/assets/code-bg.png" alt="" />
        <div class="content">
          <div class="ticket">
            <span style="fontsize: 0.4rem">￥</span>{{ ticketData.faceValue }}
          </div>

          <div>吴兴区金秋汽车消费券</div>

          <div class="code">
            <vue-qr
              class="qr-code"
              :text="ticketData.qrCode"
              :size="260"
              :logoScale="0.2"
              :correctLevel="3"
              :logoMargin="5"
            >
            </vue-qr>
            <div class="mask" v-if="ticketData.status === 1">已使用</div>
            <div class="mask" v-if="ticketData.status === 2">已过期</div>
          </div>

          <div class="tips">请将此二维码展示给商家核销</div>

          <div class="effect">有效期至{{ ticketData.expireTime }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  checkCarStatus,
  getCarCoupon,
  getCarInfo,
  robCarCoupon,
  checkUserIsReal,
  checkCanReal,
  getVerCode,
  realUserInfo,
} from "@/api/index";
import vueQr from "vue-qr";

import { debounce } from "lodash";
import Header from "./components/header";
import Rules from "./components/rules";
import Member from "./components/member";
import CodeInput from "./components/code-input.vue";

export default {
  name: "Home",
  components: {
    Header,
    Rules,
    Member,
    CodeInput,

    vueQr,
  },

  data() {
    return {
      scrollTop: 0,
      couponCode: "",
      // deviceNo: "",
      // m2oId: 0,
      // token: "",

      isSend: false,
      time: 60 * 1000,

      idCard: "",
      name: "",
      phone: "",
      verCode: "",

      countDownTimeStart: false,

      isReal: 0, //实名状态

      realEndTime: "",

      isCanReal: false, //当前能否实名
      isCanRush: false, //当前能否领取
      activityData: {},
      status: null,
      startTime: 0,

      list: [
        {
          id: 1,
          value: 1000,
          limit: "满5万可用",
        },
        {
          id: 2,
          value: 3000,
          limit: "满10万可用",
        },
        {
          id: 3,
          value: 6000,
          limit: "满20万可用",
        },
        {
          id: 4,
          value: 8000,
          limit: "满30万可用",
        },
      ],

      ticket: "",

      ticketData: {},
      beginTime: "",
      endTime: "",

      limitMap: {
        1000: "满5万可用",
        3000: "满10万可用",
        6000: "满20万可用",
        8000: "满30万可用",
      },

      ticketShow: false,

      run: false,

      city: "",
      area: "",
      storeCode: null,
      statusData: {},
    };
  },

  created() {
    this.storeCode = this.$route.query.code;
    console.log(this.storeCode);
    SmartCity.getLocation((res) => {
      console.log(res);

      this.city = res.city;
      this.area = res.area;
    });
    if (process.env.NODE_ENV == "development") {
      //   this.$store.commit("setNthUserId", 1075);
      this.$store.commit("setNthUserId", 248809);
      this.$store.commit("setNthToken", "b074b24772f32800a41f8e0a3b58d696");
      //   this.$store.commit("setNthToken", "b819f6472575f02128c5bd851dbfda74");
      this.$store.commit("setDeviceToken", "86c9ed91fcbb53b4d6854ffc8cd33b27");

      //   this.checkCanReal();
      this.checkUserIsReal();

      this.checkCarStatus();
      this.getCarCoupon();
      // this.init();
    } else {
      this.init();
    }
  },
  methods: {
    onRush(item) {
      if (this.ticket || this.status !== 0) {
        return;
      }
      this.$toast.loading({
        duration: 0,
        message: "拼命争抢中...",
      });

      this.robCarCoupon(item.value);
    },
    returnBtnText(code) {
      let btnText = "";
      for (const i in this.statusData) {
        if (i == code) {
          if (!this.statusData[i]) {
            btnText = "已领完";
          } else {
            btnText = "立即领取";
          }
        }
      }
      if (code == this.ticket) {
        btnText = "您已领取";
      }
      return btnText;
    },
    canUse(item) {
      let code;
      if (item) {
        code = +item.value;
      }
      let res = true;
      if (this.status === 2 || this.status === 4) {
        res = false;
      }
      for (const i in this.statusData) {
        console.log('!this.statusData[i]======'+!this.statusData[i]);
        if (i == code && !this.statusData[i]) {
          res = false;
        }
      }
      // console.log(res);
      if (this.ticket && code != this.ticket) {
        res = false;
      }
      if (code == this.ticket) {
        res = true;
      }
      return res;
    },

    onTimeFinish() {
      // if (this.startTime) {
      // console.log('');
      this.isCanRush = true;
      this.status = 0;
      // }
    },
    onSubmit() {
      if (!this.name) {
        return this.$toast("请填写真实姓名");
      } else if (!this.idCard) {
        return this.$toast("请填写身份证号码");
      } else if (this.phone.length !== 11) {
        return this.$toast("请输入正确的手机号");
      }

      this.getVerCode();
    },

    onSendFinish() {
      this.isSend = false;
    },

    onCodeSubmit() {
      this.verCode = this.$refs.codeRef.code;
      this.realUserInfo();
    },

    onCheckTicket() {
      this.getCarInfo();
      // this.ticketShow = true;
      // this.$refs.codeRef.popupShow = false;
    },

    //获取活动信息
    async checkCarStatus() {
      const { data: res } = await checkCarStatus();

      console.log("活动状态", res);
      if (res.code == 200) {
        this.statusData = res.data;
        this.status = res.data.status;
        // this.status = 0;

        this.startTime =
          Date.parse(new Date(res.data.nextStartTime)) - res.data.nowDate;
        // this.startTime =
        //     Date.parse(new Date("2022/05/20 10:00:00")) - 1653011990000;

        this.run = true;
      }
    },

    //获取领券状态
    async getCarCoupon() {
      const { data: res } = await getCarCoupon();

      console.log("领券状态", res);
      if (res.code == 200) {
        let resData = res.data;
        if (resData.faceValue) {
          this.ticket = resData.faceValue;
          // this.beginTime = resData.beginTime;
          //   this.endTime = resData.endTime;
        }
      }
    },

    //获取的券详情
    async getCarInfo() {
      const { data: res } = await getCarInfo();

      console.log("已领到的券的信息", res);
      if (res.code == 200) {
        this.ticketData = res.data[res.data.length - 1];
        this.ticketShow = true;
        // this.goodsInfo = res.data;
      }
    },

    //抢券
    async robCarCoupon(couponCode) {
      //   if (this.city !== "湖州市" && !this.loc.includes("Huzhou")) {
      //     this.$toast.fail("非常抱歉，您不在活动区域。");
      //     return;
      //   }
      const { data: res } = await robCarCoupon({
        couponCode,
        deviceNo: this.$store.state.deviceToken,
        m2oId: this.$store.state.m2oId,
        token: this.$store.state.token,
        area: this.city + this.area,
        storeCode: this.storeCode,
      });

      console.log("rushB!!!!!!!!!", res);
      if (res.code == 200) {
        this.$toast.success("领取成功");
        this.getCarCoupon();
      }
    },

    //获取验证码
    async getVerCode() {
      const { data: res } = await getVerCode({
        phone: this.phone,
      });

      if (res.code == 200) {
        this.$refs.codeRef.popupShow = true;
        this.isSend = true;
      }

      console.log("验证码", res);
    },

    //获取实名认证状态
    async checkUserIsReal() {
      const { data: res } = await checkUserIsReal();

      console.log("实名认证状态", res);
      if (res.code == 200) {
        this.isReal = res.data.isReal;
        // this.isReal = 1;
      }
    },

    //获取能否实名认证
    async checkCanReal() {
      const { data: res } = await checkCanReal();

      console.log("能否实名", res);
      if (res.code == 200) {
        if (res.data.isReal === 1) {
          this.isCanReal = true;
        }
        this.realEndTime = res.data.realEndTime;
      }
    },

    async realUserInfo() {
      const { data: res } = await realUserInfo({
        idCard: this.idCard,
        name: this.name,
        phone: this.phone,
        verCode: this.verCode,
      });

      console.log("实名认证", res);
      if (res.code == 200) {
        this.$toast.clear();
        this.$refs.codeRef.popupShow = false;

        this.checkUserIsReal();
      }
    },

    init() {
      const isApp = SmartCity.isSmartCityApp();
      if (isApp) {
        this.getNthUserInfo();
      } else {
        // return this.$toast.fail("请在南太湖号App中打开！");

        this.$router.replace("/share");
      }
    },

    getNthUserInfo() {
      this.$toast.loading({
        duration: 0,
        message: "初始化...",
      });
      SmartCity.getUserInfo((res) => {
        if (res && res.userInfo) {
          this.$toast.clear();

          // this.m2oId = res.userInfo.userid;
          // this.token = res.userInfo.userTokenKey;
          this.$store.commit("setNthUserId", res.userInfo.userid);
          this.$store.commit("setNthToken", res.userInfo.userTokenKey);

          //   this.checkCanReal();
          this.checkUserIsReal();
          this.checkCarStatus();
          this.getCarCoupon();

          SmartCity.getSystemInfo((res2) => {
            // this.deviceNo = res2.deviceInfo.device_token;
            this.$store.commit("setDeviceToken", res2.deviceInfo.device_token);
          });
        } else {
          this.$toast.clear();
          this.$dialog
            .alert({
              title: "提醒",
              message: "请先登录南太湖号",
            })
            .then(() => {
              this.$router.replace("/error-nologin");
            });
        }
      });
    },
    toScan() {
      SmartCity.scanQRCode(function (res) {
        window.location.href = res.resultStr;
      });
    },
  },

  mounted() {
    this.$refs.container.onscroll = debounce(() => {
      this.scrollTop = this.$refs.container.scrollTop;
    }, 10);
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: calc(100vh);
  overflow-y: scroll;

  // background: chocolate;
  // background: #0287ef;

  .main {
    background: #0f6ad3;
    position: relative;

    .banner {
      width: 100%;
    }

    .main-wrap {
      // position: absolute;

      position: absolute;
      height: 340px;
      bottom: 180px;
      left: 0;
      right: 0;

      // background: #ccc;

      .time {
        color: #fff;
        text-align: center;
        margin-bottom: 10px;
        display: flex;
        // flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        span {
          margin-right: 10px;
        }

        .van-count-down {
          color: @main;
        }
      }

      .ticket {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        .item {
          width: 130px;
          height: 124px;
          background: url("../../assets/ticket1.png") no-repeat;
          background-size: 100% 100%;
          margin: 8px;

          .top {
            height: 70%;

            .info {
              // width: 80%;
              display: flex;
              flex-direction: column;
              text-align: center;

              .title {
                font-size: 24px;
                font-weight: bold;
                color: @main;
                padding: 10px;
              }
              .tips {
                // padding: 4px 0;
                color: #666;
              }

              .date {
                font-size: 12px;
                color: #999;
              }
            }
          }

          .bottom {
            height: 30%;
            text-align: center;
            font-size: 16px;
            color: #fff;

            // display: flex;
            // justify-content: space-between;
            // align-items: center;
            // position: relative;

            .btn {
              width: 100%;

              // border-radius: 15px;
              // background: @main;
              // margin-right: 10px;
            }
          }
        }
      }
    }

    .form-wrap {
      padding: 20px 40px;
      position: absolute;
      height: 340px;
      bottom: 220px;
      left: 0;
      right: 0;
      z-index: 1;

      .tips {
        color: #fff;
        text-align: center;
        padding: 10px;
      }

      .tips-cannot-real {
        margin-top: 90px;
        color: #fff;
        text-align: center;
        div {
          font-size: 20px;
        }
        div:nth-child(2) {
          font-size: 14px;
          margin-top: 10px;
        }
        div:nth-child(3) {
          font-size: 20px;
          margin-top: 15px;
        }
        div:nth-child(4) {
          font-size: 16px;
          margin-top: 10px;
        }
      }

      .btn {
        background: @main;
        padding: 0.26667rem 0.42667rem;
        overflow: hidden;
        color: #fff;
        font-size: 0.37333rem;
        line-height: 0.64rem;

        // margin-bottom: 14px;
        border-radius: 20px;
        text-align: center;
      }

      .van-cell {
        padding: 0.26667rem 0.42667rem;
        overflow: hidden;
        color: #323233;
        font-size: 0.37333rem;
        line-height: 0.64rem;
        background-color: #fff;
        margin-bottom: 20px;

        border-radius: 20px;
      }
    }
  }

  .ticket-wrap {
    position: relative;
    z-index: 1;
    padding: 10px;
    margin: 0 auto;
    margin-top: -20px;
    background: #0287ef;

    margin-bottom: 30px;

    .ticket {
      height: 100px;
      background: url("../../assets/ticket.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      .left {
        width: 30%;

        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        color: #fff;
      }

      .right {
        padding: 10px;
        width: 70%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        .info {
          // width: 80%;
          display: flex;
          flex-direction: column;
          .title {
            font-size: 16px;
            font-weight: bold;
          }
          .tips {
            padding: 4px 0;
            color: #666;
          }

          .date {
            font-size: 12px;
            color: #999;
          }
        }

        .btn {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          padding: 6px 10px;

          text-align: center;
          font-size: 12px;
          color: #fff;
          border-radius: 15px;
          background: @main;
          // margin-right: 10px;
        }
      }
    }
  }

  .info-wrap {
    border-radius: 10px;
    width: 300px;
    position: relative;
    .content {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      // background: #ccc;
      text-align: center;
      .ticket {
        font-size: 20px;
        font-weight: bold;
        color: @main;
        padding: 20px;
      }

      .code {
        width: 200px;
        height: 200px;
        margin: 0 auto;

        position: relative;
        .mask {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          color: #fff;

          font-size: 20px;
          line-height: 200px;
        }
      }

      .effect {
        position: absolute;
        bottom: 40px;
        left: 0;
        right: 0;
      }
    }

    img {
      width: 100%;
    }
  }
  .van-popup {
    position: fixed;
    max-height: 100%;
    overflow-y: auto;
    background-color: transparent;
  }
}

/deep/.van-toast {
  z-index: 99999;
}
.grey-bg {
  background: #ccc !important;
}

.filter {
  // -webkit-filter: grayscale(100%);
  // -moz-filter: grayscale(100%);
  // -ms-filter: grayscale(100%);
  // -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
  // filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
}

.van-count-down {
  color: #fff;
}
.container::-webkit-scrollbar {
  display: none;
}
.getOneBtn {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  width: 150px;
  height: 40px;
  margin: -100px auto;
  background: #ffffff;
  border-radius: 20px 20px 20px 20px;
  opacity: 1;
  font-size: 16px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #002981;
  line-height: 20px;
  text-align: center;
  .scanIcon {
    width: 20px;
    height: 20px;
    background: url("../../assets/icon-scan.png") center center no-repeat;
    background-size: cover;
    margin-right: 10px;
    filter: hue-rotate(197deg) contrast(120%) brightness(50%);
  }
}
.flexCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
